export const dateToString = (date) =>
  `${date.monthValue}/${date.dayOfMonth}/${date.year}`;

export function dateToMMDDYY(dateAsDate) {
  if (dateAsDate)
    return `${dateAsDate.getMonth() + 1
      }/${dateAsDate.getDate()}/${dateAsDate.getFullYear()}`;
  return null;
}

export function dateToMMDDYYmm(dateAsDate) {
  if (dateAsDate)
    return `${dateAsDate.getMonth() + 1
      }/${dateAsDate.getDate()}/${dateAsDate.getFullYear()} ${dateAsDate.getHours()}:${dateAsDate.getMinutes()}`;
  return null;
}

export function dateToMMDDYY2(dateAsDate) {
  return `${dateAsDate.getFullYear()}-${`0${dateAsDate.getMonth() + 1}`.slice(
    -2
  )}-${`0${dateAsDate.getDate()}`.slice(-2)}`;
}

export const getDate = (value) => {
  if (value) {
    if (value instanceof Date) {
      return value;
    }
    if (typeof value === "string") {
      return new Date(value);
    }
    if (value.length === 3) return new Date(value[0], value[1] - 1, value[2]);
    return new Date(
      value[0],
      value[1] - 1,
      value[2],
      value[3],
      value[4],
      value[5]
    );
  }

  return null;
};

export const getRawDate = (date) => [
  date.getFullYear(),
  date.getMonth() + 1,
  date.getDate(),
];

export const getFormattedDateFromDayjs = (date) => date.format("YYYY-MM-DD");

export const getRawDateFromDayjs = (date) => [
  date.year(),
  date.month() + 1,
  date.date(),
];
